export const mailModuleName = "_na";
export default {mailModuleName};